module.exports = __webpack_public_path__ + "static/allcardis-2592be4d6156f9ceb5e58124adeb170f.jpeg";